export type Theme = "light" | "dark";

export const THEME_STORAGE_KEY = "lms-theme";
export const THEME_ATTRIBUTE = "data-theme";

/** Astromania is light-first: the OS is consulted only when nothing is stored. */
export const DEFAULT_THEME: Theme = "light";
